export default function (state, getters, rootState, rootGetters) {
    return rootState.settings.regulars.load || state.list.loading || rootState.dictionary.user.load;
}